export enum ModalName {
  FilesImporter = 'filesImporterModal',
  MoveTo = 'moveToModal',
  ShutterstockDisabled = 'shutterstockDisabledModal',
  CancelAllUploads = 'cancelAllUploadingModal',
  EditBoard = 'editBoardModal',
  AddFilesToBoard = 'addFilesToBoardModal',
  DeleteBoard = 'deleteBoardModal',
  PermanentDelete = 'permanentDeleteModal',
  StorageFull = 'storageFullModal',
}
